// Usersnap initialization script
// This script loads Usersnap with the API key from environment variables

// Get the API key from the environment
const usersnapApiKey = import.meta.env.VITE_USERSNAP_API_KEY;

// Initialize Usersnap callback
window.onUsersnapLoad = function (api) {
  // Wait for api.init() to fully resolve before setting window.Usersnap.
  // The Usersnap SDK's logEvent method is only reliable after init() completes —
  // calling it before that silently drops the event (the internal event listener
  // machinery isn't ready). Gating window.Usersnap behind the promise ensures
  // any caller checking window.Usersnap gets a fully-ready SDK.
  api.init().then(() => {
    window.Usersnap = api;

    // Drain any CSAT logEvent that was queued before init() resolved.
    // fireUsersnapCsatEvent (usersnap.ts) writes here when window.Usersnap
    // is not yet set (i.e. student completes a lesson before init() finishes).
    if (window.__csatPendingPayload) {
      api.logEvent("student_lesson_csat_trigger");
      window.__csatPendingPayload = undefined;
    }
  });
};

// Only load Usersnap if we have a valid API key
if (usersnapApiKey && usersnapApiKey.length > 10) {
  const script = document.createElement("script");
  script.defer = true;
  script.src = `https://widget.usersnap.com/global/load/${usersnapApiKey}?onload=onUsersnapLoad`;
  document.head.appendChild(script);
} else {
  // Create a mock Usersnap object to prevent errors
  window.Usersnap = {
    show: () =>
      Promise.reject(new Error("Usersnap not initialized - API key missing")),
    hide: () => {},
    on: () => {},
    logEvent: () => {}
  };
}
